import { zonedTimeToUtc, utcToZonedTime } from 'date-fns-tz';

import { addressComponentRequired } from './lib';
import { getTimezone } from '../../../../services/maps';
import { defaultDietaryRestrictions } from '../MealInfo';

export default async (values, formikBag, state, dispatch) => {
	const { setFieldValue, setValues } = formikBag;
	const {
		timezone: previousTimezone,
		deliveryDate: previousDeliveryDate,
		state: locationState,
		ClientId,
		ClientLocationId,
	} = values;

	const clientLocationKey = `${ClientId}:${ClientLocationId}`;
	const shouldApplyLocationDefaults =
		clientLocationKey !== state.defaultsAppliedForClientLocationKey;

	let newTimezone;
	let headCount = values.headCount;
	let deliveryInstructions = values.deliveryInstructions;
	let setupInstructions = values.setupInstructions;
	let dietaryRestrictions = values.dietaryRestrictions;
	let budgetType = values.budgetType;
	let budget = values.budget;

	if (addressComponentRequired(state)(ClientId, ClientLocationId)) {
		newTimezone = getTimezone(locationState);

		if (shouldApplyLocationDefaults) {
			headCount = '';
			deliveryInstructions = '';
			setupInstructions = '';
			dietaryRestrictions = defaultDietaryRestrictions;
			budgetType = '';
			budget = '';
		}
	} else {
		const clientLocation = state.contactData.Clients.find(
			({ id }) => id === ClientId
		).ClientLocations.find(({ id }) => id === ClientLocationId);

		const { budgetPerPerson, totalBudget } = clientLocation;

		newTimezone = clientLocation.timezone;

		if (shouldApplyLocationDefaults) {
			headCount = clientLocation.headCount || '';
			deliveryInstructions = clientLocation.deliveryInstructions || '';
			setupInstructions = clientLocation.setupInstructions || '';
			dietaryRestrictions = clientLocation.dietaryRestrictions || '';
			budgetType = '';
			budget = '';

			if (budgetPerPerson) {
				budgetType = 'perPerson';
				budget = budgetPerPerson;
			} else if (totalBudget) {
				budgetType = 'total';
				budget = totalBudget;
			}
		}
	}

	setValues({
		...values,
		headCount,
		deliveryInstructions,
		setupInstructions,
		dietaryRestrictions,
		budget,
		budgetType,
		timezone: newTimezone,
	});

	if (shouldApplyLocationDefaults) {
		dispatch({
			type: 'setStateValue',
			payload: {
				key: 'defaultsAppliedForClientLocationKey',
				value: clientLocationKey,
			},
		});
	}

	if (previousDeliveryDate && newTimezone !== previousTimezone) {
		let newDeliveryDate = utcToZonedTime(
			previousDeliveryDate,
			previousTimezone
		);
		newDeliveryDate = zonedTimeToUtc(newDeliveryDate, newTimezone);

		setFieldValue('deliveryDate', newDeliveryDate);
	}
};
